import { apiClient } from './client';

export interface LoginResponse {
  token: string;
  login: string;
}

export async function apiLogin(login: string, password: string): Promise<LoginResponse> {
  const res = await apiClient.post<LoginResponse>('/auth/login', { login, password });
  return res.data;
}
